import {apiClient, queryClient} from '@common/http/query-client';
import {useQuery} from '@tanstack/react-query';
import {PolicyFailReason} from '@common/billing/upgrade/policy-fail-reason';
import {editorHeavyQueryOptions} from '@app/editor/ai-assistant/editor-ai-query-options';

interface ResourceStatus {
  allowed: boolean;
  failReason?: PolicyFailReason;
}

interface ResourceUsage {
  used: number;
  total: number;
  create: ResourceStatus;
  update: ResourceStatus;
  delete: ResourceStatus;
}

// Тип AiUsage (hasPermission, used, total, failReason) удалён 2026-02-20 — API ai возвращает только credits

interface Response {
  ai: {
    credits: number;
  };
  plan?: import('@common/billing/use-account-plan').AccountPlanSummary | null;
  // published_* добавлены 2026-04-17 — лимит опубликованных сайтов (projects.publish, restriction count).
  // Изменено: 2026-05-03 — export (FTP) убран из API usage.
  // Изменено: 2026-08-20 — раздельные слоты сайта и магазина.
  projects: ResourceUsage & {
    customCode: boolean;
    download: boolean;
    published_used: number;
    published_total: number | null;
    published_sites_used?: number;
    published_sites_total?: number | null;
    published_stores_used?: number;
    published_stores_total?: number | null;
  };
  custom_domains: ResourceUsage;
  uploads: {
    used: number;
    total: number;
  };
}

export function useAccountUsage() {
  return useQuery({
    queryKey: ['account-usage'],
    queryFn: () => fetchUsage(),
    staleTime: 60_000,
    ...editorHeavyQueryOptions,
  });
}

export function reloadAccountUsage() {
  return queryClient.invalidateQueries({
    queryKey: ['account-usage'],
  });
}

function fetchUsage() {
  return apiClient
    .get<Response>(`account/usage`)
    .then(response => response.data);
}
